import Modal from '../ui/modals';
import CurrencyIcon from '../ui/icons/currency-icon';
import Image from '@/components/image';

const options = [
  {
    'title-ar': 'أضف العنصر إلى سلة التسوق الخاصة بك',
    'title-en': 'Add the item to your cart',
    icon: 'cart',
  },
  {
    'title-ar': 'حدد MISPAY عند الخروج',
    'title-en': 'Select MISPAY at checkout',
    icon: 'select-mispay',
  },
  {
    'title-ar': 'املأ التفاصيل الخاصة بك',
    'title-en': 'Fill in your details',
    icon: 'fill-form',
  },
  {
    'title-ar': 'أكمل دفعتك الأولى',
    'title-en': 'Complete your first payment',
    icon: 'pay',
  },
];

const months = [
  { index: 0, 'name-en': 'Jan', 'name-ar': 'يناير', lastDay: '31' },
  { index: 1, 'name-en': 'Feb', 'name-ar': 'فبراير', lastDay: null },
  { index: 2, 'name-en': 'Mar', 'name-ar': 'مارس', lastDay: '31' },
  { index: 3, 'name-en': 'Apr', 'name-ar': 'أبريل', lastDay: '30' },
  { index: 4, 'name-en': 'May', 'name-ar': 'مايو', lastDay: '31' },
  { index: 5, 'name-en': 'Jun', 'name-ar': 'يونيو', lastDay: '30' },
  { index: 6, 'name-en': 'Jul', 'name-ar': 'يوليو', lastDay: '31' },
  { index: 7, 'name-en': 'Aug', 'name-ar': 'أغسطس', lastDay: '31' },
  { index: 8, 'name-en': 'Sep', 'name-ar': 'سبتمبر', lastDay: '30' },
  { index: 9, 'name-en': 'Oct', 'name-ar': 'أكتوبر', lastDay: '31' },
  { index: 10, 'name-en': 'Nov', 'name-ar': 'نوفمبر', lastDay: '30' },
  { index: 11, 'name-en': 'Dec', 'name-ar': 'ديسمبر', lastDay: '31' },
];

function getNextMonthIndex(currentMonthIndex) {
  let nextMonthIndex = currentMonthIndex + 2;

  if (nextMonthIndex <= 12) {
    return nextMonthIndex;
  } else if (nextMonthIndex === 13) {
    return 0;
  } else if (nextMonthIndex === 14) {
    return 1;
  }
}

const MisPayModal = ({ amount, locale, show, setShow }) => {
  const februaryLastDay = new Date(new Date().getFullYear(), 1, 0).getDate();
  months[1].lastDay = februaryLastDay;
  const currentMonthIdx = new Date().getMonth();
  return (
    <Modal maxWidth='max-w-fit' onClose={() => setShow(false)} isOpen={show}>
      <div className='fixed start-1/2 top-1/2 z-[9999] flex -translate-y-1/2 flex-col gap-4 overflow-hidden rounded-xl bg-white p-2 shadow-lg max-sm:w-[97%] lg:h-fit lg:p-4 ltr:-translate-x-1/2 rtl:translate-x-1/2'>
        <h3 className='text-center text-xs font-bold lg:text-sm'>
          {locale === 'ar'
            ? 'قم بتقسيم مشترياتك إلى 4 دفعات بدون فوائد، وبدون رسوم تأخير. متوافق مع الشريعة الإسلامية.'
            : 'Split your purchase into 4 interest-free payments, No late fees. sharia-compliant.'}
        </h3>
        <div className='relative flex justify-center gap-10 max-[991px]:gap-5'>
          <div className='absolute top-4 left-1/2 z-0 h-0.5 w-11/12 -translate-x-1/2 bg-[#6322D0] sm:w-5/6' />
          {[1, 2, 3, 4]?.map((item, idx) => (
            <div
              key={'mis-' + idx}
              className='z-10 flex flex-col items-center gap-4'
            >
              <div className='flex size-9 items-center justify-center rounded-full border-2 border-[#6322D0] bg-white'>
                {item}
              </div>
              <p className='flex flex-col justify-center text-center'>
                <span className='flex items-center gap-1 text-sm'>
                  {(amount / 4)?.toFixed(2)}{' '}
                  <CurrencyIcon className='size-3.5' />
                </span>
                {item === 1 && (
                  <span className='text-xs'>
                    {locale === 'ar' ? 'اليوم' : 'Today'}
                  </span>
                )}
                {item === 2 && (
                  <span className='text-xs'>
                    {
                      months?.[getNextMonthIndex(currentMonthIdx)]?.[
                        'name-' + locale
                      ]
                    }{' '}
                    {`${
                      months[getNextMonthIndex(currentMonthIdx)]?.lastDay
                    }`?.concat(
                      locale === 'en'
                        ? months[getNextMonthIndex(currentMonthIdx)]
                            ?.lastDay === '31'
                          ? 'st'
                          : 'th'
                        : ''
                    )}
                  </span>
                )}
                {item === 3 && (
                  <span className='text-[12px]'>
                    {
                      months?.[getNextMonthIndex(currentMonthIdx + 1)]?.[
                        'name-' + locale
                      ]
                    }{' '}
                    {`${
                      months[getNextMonthIndex(currentMonthIdx + 1)]?.lastDay
                    }`?.concat(
                      locale === 'en'
                        ? months[getNextMonthIndex(currentMonthIdx + 1)]
                            ?.lastDay === '31'
                          ? 'st'
                          : 'th'
                        : ''
                    )}
                  </span>
                )}
                {item === 4 && (
                  <span className='text-[12px]'>
                    {
                      months?.[getNextMonthIndex(currentMonthIdx + 2)]?.[
                        'name-' + locale
                      ]
                    }{' '}
                    {`${
                      months[getNextMonthIndex(currentMonthIdx + 2)]?.lastDay
                    }`?.concat(
                      locale === 'en'
                        ? months[getNextMonthIndex(currentMonthIdx + 2)]
                            ?.lastDay === '31'
                          ? 'st'
                          : 'th'
                        : ''
                    )}
                  </span>
                )}
              </p>
            </div>
          ))}
        </div>
        <div className='w-full bg-[#faf9f9] p-2'>
          <p className='text-center font-bold max-sm:text-sm'>
            {locale === 'ar' ? 'كيفية استخدام MISPay' : 'How to use MISPay'}
          </p>
          <div className='mt-4 grid grid-cols-2 gap-4'>
            {options?.map((opt) => (
              <div key={opt.icon} className='flex flex-col gap-4'>
                <Image
                  src={`/imgs/payments/${opt.icon}.svg`}
                  alt={opt['title-' + locale]}
                  className='h-[18px] object-contain'
                />
                <p className='text-center text-xs lg:text-sm'>
                  {opt['title-' + locale]}
                </p>
              </div>
            ))}
          </div>
          <button
            onClick={() => setShow(false)}
            className='mx-auto mt-5 flex w-[232px] items-center justify-center rounded-lg bg-[#6322D0] py-1.5 text-xs text-white hover:bg-[#6322D0]/90 lg:text-sm'
          >
            {locale === 'ar' ? 'مواصلة التسوق' : 'Continue Shopping'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default MisPayModal;
